import { gql } from '@apollo/client';

export default gql`
  query PricingPage($languages: [String], $url_key: String) {
    content {
      pricing_pages(filter: { url_key: { _eq: $url_key } }) {
        translations(
          filter: { languages_code: { code: { _in: $languages } } }
        ) {
          page_title
          meta_title
          meta_description
        }
        layout {
          collection
          item {
            __typename
            ... on pricing_pages_single_layout {
              ...singleLayout
            }
            ... on pricing_pages_multi_layout {
              ...multiLayout
            }
          }
        }
      }
    }
  }

  fragment singleLayout on pricing_pages_single_layout {
    content(
      limit: 1
      filter: { languages_code: { code: { _in: $languages } } }
    ) {
      bottom_content
      languages_code {
        code
      }
    }
    show_retailer_button
    product {
      title
      sku
      image {
        filename_disk
      }
      system_requirements {
        system_requirements_id {
          translations(
            filter: { languages_code: { code: { _in: $languages } } }
          ) {
            languages_code {
              code
            }
            content
          }
        }
      }
      translations(filter: { languages_code: { code: { _in: $languages } } }) {
        subtitle
        additional_information
        product_includes
        system_requirments
        languages_code {
          code
        }
      }
    }
  }

  fragment multiLayout on pricing_pages_multi_layout {
    grid_columns
    show_retailer_button
    translations(filter: { languages_code: { code: { _in: $languages } } }) {
      content_top
      content_bottom
      find_dealer_text
      extra_information
      languages_code {
        code
      }
    }
    products {
      products_id {
        title
        sku
        image {
          filename_disk
        }
        translations(
          filter: { languages_code: { code: { _in: $languages } } }
        ) {
          subtitle
          system_requirments
          multiproduct_layout_content
          languages_code {
            code
          }
        }
      }
    }
  }
`;
